import { Component, Input, OnInit } from '@angular/core';
import { CourierRepo } from 'src/app/core/repositories/courier.repo';
import { ToastPosition, ToastService } from 'src/app/core/services/toast.service';
import { catchError } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { ModalController } from '@ionic/angular';
import { CameraService } from 'src/app/core/services/camera.service';

@Component({
  selector: 'app-order-delivered-photo',
  templateUrl: './order-delivered-photo.component.html',
  styleUrls: ['./order-delivered-photo.component.scss'],
})
export class OrderDeliveredPhotoComponent implements OnInit {
  @Input({ required: true }) orderId!: string;
  safeImageUrl?: string;
  blob?: Blob;

  constructor(
    private modalController: ModalController,
    private courierRepo: CourierRepo,
    private toastService: ToastService,
    private cameraService: CameraService,
  ) { }

  ngOnInit(): void {
    this.takePhoto();
  }

  async close(): Promise<void> {
    const topModal = await this.modalController.getTop();
    if (topModal) {
      await this.modalController.dismiss();
    }
  }

  async takePhoto(): Promise<void> {
    const cameraResult = await this.cameraService.takePhoto();
    this.safeImageUrl = cameraResult?.sanitizedUrl;
    this.blob = cameraResult?.blob;
  }



  async uploadPhoto(): Promise<void> {
    this.courierRepo.sendEmailDeliveredOrder(this.orderId, this.blob!)
      .pipe(catchError(() => {
        this.showErrorToast();
        return EMPTY;
      }))
      .subscribe(() => {
        this.close();
        this.showSuccessToast();
      });
  }

  clearImage($event: Event): void {
    $event.preventDefault();
    this.safeImageUrl = undefined;
    this.blob = undefined;
  }

  private showSuccessToast(): void {
    this.toastService.showSuccessToast("Afbeelding is succesvol opgeslagen", ToastPosition.Top, 2000);
  }

  private showErrorToast(): void {
    this.toastService.showErrorToast("Opslaan is mislukt, probeer later opnieuw", ToastPosition.Top, 2000);
  }
}
